module.exports = __webpack_public_path__ + "static/tfoundation-510f4dcc56552ad31e498c571ef8c553.png";